// extracted by mini-css-extract-plugin
module.exports = {"unoptimizedImage":"unoptimizedImage___3-SY7","unoptimizedImageWrapper":"unoptimizedImageWrapper___1Kkpn"};